import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'tile-connector',
    templateUrl: './tile-connector.component.html',
    styleUrls: ['./tile-connector.component.scss'],
})
export class TileConnectorComponent implements OnInit {
    constructor() {}

    @Input() addNew: boolean;
    @Input() isAllBtnHidden: boolean;
    @Output() addNewOrCancel: EventEmitter<string> = new EventEmitter<string>();
    isAddNewHidden = false;
    isCancelHidden = false;

    ngOnInit() {
        if (this.addNew) {
            this.isAddNewHidden = false;
            this.isCancelHidden = true;
        } else if (this.addNew === false) {
            this.isAddNewHidden = true;
            this.isCancelHidden = false;
        }
    }

    iconClicked(action: string) {
        this.addNewOrCancel.emit(action);
    }
}
